import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorage } from 'src/app/enums/local-storage-key.enum';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { OrderSummaryServiceService } from 'src/app/services/order-summary-service.service';

@Component({
  selector: 'app-order-category-group',
  templateUrl: './order-category-group.component.html',
  styleUrls: ['./order-category-group.component.css']
})
export class OrderCategoryGroupComponent implements OnInit {
  
  @Input() title: string;
  @Input() icon: string;
  @Input() total: string | number = 0;
  constructor(
    private orderSummary: OrderSummaryServiceService,
    private localStorageService: LocalStorageService,
    private router: Router) { }

  ngOnInit(): void {
  }

  get totalOrder(): number {
    return this.orderSummary.total;
  }
  get totalPaid(): number {
    return this.orderSummary.paid;
  }
  get totalUnpaid(): number {
    return this.orderSummary.unpaid;
  }

  get totalInPayment(): number {
    return this.orderSummary?.inpayment || 0;
  }

  onSearchChange(status?: string) {
    this.localStorageService.set(LocalStorage.status, status);
    this.router.navigate(['/order']);
  }
}

